import { render, staticRenderFns } from "./BlogPostParagraphsImageSection.vue?vue&type=template&id=9935dd3c&scoped=true"
import script from "./BlogPostParagraphsImageSection.vue?vue&type=script&lang=js"
export * from "./BlogPostParagraphsImageSection.vue?vue&type=script&lang=js"
import style0 from "./BlogPostParagraphsImageSection.vue?vue&type=style&index=0&id=9935dd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9935dd3c",
  null
  
)

export default component.exports